import axios from 'axios';

// Use REACT_APP_API_BASE from .env (e.g., https://carrierfinderpro.com/)
const API_BASE = process.env.REACT_APP_API_BASE || 'https://carrierfinderpro.com/';
const API_URL = API_BASE.replace(/\/$/, '') + '/api';

const getAuthHeader = () => {
  const token =
    localStorage.getItem('cfp_token') ||
    localStorage.getItem('token') ||
    '';
  if (!token) return {};
  return { Authorization: `Bearer ${token}`, 'X-Auth-Token': token };
};

/**
 * Email Warmup API Service
 */
export const warmupApi = {
  /**
   * Initialize warmup for an account
   */
  initializeWarmup: async (accountId) => {
    try {
      const response = await axios.post(
        `${API_URL}/warmup.php/initialize/${accountId}`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error initializing warmup:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Get warmup status for an account
   */
  getWarmupStatus: async (accountId) => {
    try {
      const response = await axios.get(
        `${API_URL}/warmup.php/status/${accountId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, data: null };
      }
      console.error('Error getting warmup status:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Get all warmup statistics
   */
  getAllWarmupStats: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/warmup.php/stats`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error getting warmup stats:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Pause warmup for an account
   */
  pauseWarmup: async (accountId) => {
    try {
      const response = await axios.post(
        `${API_URL}/warmup.php/pause/${accountId}`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error pausing warmup:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Resume warmup for an account
   */
  resumeWarmup: async (accountId) => {
    try {
      const response = await axios.post(
        `${API_URL}/warmup.php/resume/${accountId}`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error resuming warmup:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Manually trigger warmup email (for testing)
   */
  triggerWarmup: async (accountId) => {
    try {
      const response = await axios.post(
        `${API_URL}/warmup.php/trigger/${accountId}`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error triggering warmup:', error);
      throw error.response?.data || error;
    }
  }
};

export default warmupApi;
